<app-content>
  <app-breadcrumbs>
    <li>
      <a routerLink='/wnioski-zatwierdzone' aria-label='Wnioski zatwierdzone'>
        Wnioski zatwierdzone
      </a>
    </li>
    <li>
      {{ serviceType()?.name }}
    </li>
  </app-breadcrumbs>
  <section>
    <br>
    <app-alert-container [dismissible]='false'></app-alert-container>
    @if (!loading()) {
      <div class="row">
        <div class="col-12">
          <div class='download-actions' *ngIf='application()'>
            @if (showPaymentBtn()) {
              <a href='#'
                 class='btn btn-secondary'
                 [routerLink]='"../../../zaplac-online/zalaczniki/" + applicationId'
                 title='Przejdź do strony, aby dokonać płatności online'>
                Dokonaj płatności online
              </a>
            }
            <a
              *ngIf='!!application()?.signedDocument?.id'
              href='#'
              title='Pobierz wniosek podpisany XML'
              class='btn btn-secondary'
              (click)='onDownloadSignedApplication($event)'>
              <i aria-hidden='true' class='fa fa-download'></i>
              Pobierz wniosek podpisany XML
            </a>
          </div>
        </div>
      </div>
      <h2>
        {{ serviceType()?.name }}
      </h2>
      <app-application-preview [application]="application()">
      </app-application-preview>
    }
    <ng-container *ngIf='!loading()'>
      <br>
      <div class='application-actions'>
        <button
          type='button'
          class='btn btn-secondary' routerLink='../../'>
          <span>
            Wstecz
          </span>
        </button>
        <button
          *ngIf='!!application()?.signedDocument?.id && !application()?.sentAt'
          [disabled]='pending()'
          (click)='sendApplication()'
          type='button'
          class='btn btn-primary'>
          <span>Wyślij wniosek</span>
        </button>
        @if (!env.production) {
          <button
            *ngIf='!application()?.signedDocument?.id'
            [disabled]='pending()'
            (click)='fakeSign()'
            type='button'
            class='btn btn-primary'>
            <span>Podpisz wniosek demo</span>
          </button>
        }
        <button
          *ngIf='!application()?.signedDocument?.id'
          [disabled]='pending()'
          (click)='signApplication()'
          type='button'
          class='btn btn-primary'>
          <span>Podpisz wniosek</span>
        </button>
      </div>
    </ng-container>
    <app-spinner *ngIf='loading()'>
      Poczekaj trwa ładowanie danych...
    </app-spinner>
  </section>
</app-content>
